import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import { map } from 'lodash';
import './setup.scss';

const menu = {
  1: 'info',
  2: 'inventory',
  3: 'configuration',
};

const SetupNavigation = memo(({ history, groupId, step = 0 }) => {
  const renderMenu = useMemo(
    () =>
      map(menu, (value, key) => {
        const active = (!step && key === '1') || step === Number(key);
        return (
          <div className="setup-link-container" key={value}>
            <Button
              key={value + groupId}
              onClick={() => {
                history.push(`/group/${groupId}/setup/${key}`);
              }}
              className={classNames(
                'btn',
                'btn-circle',
                'setup-btn',
                active && 'btn-primary',
              )}
            >
              {key}
            </Button>
            <div>{value}</div>
          </div>
        );
      }),
    [groupId, history, step],
  );

  if (!groupId) {
    return null;
  }

  return (
    <div className="setup-nav">
      {renderMenu}
      <div className="setup-nav-baseline" />
    </div>
  );
});

SetupNavigation.propTypes = {
  history: PropTypes.object,
  groupId: PropTypes.string,
  step: PropTypes.number,
};

export default SetupNavigation;
